module.exports = __webpack_public_path__ + "static/ibm-watson-logo-ed90fd4c34676f11e20ef904c4500f12.mp4";